export const dnsInitialState = {
  ip: [],
  dnsStatus: true,
  isLoading: false,
  isError: null
};
